export default __webpack_public_path__ + "static/media/sprite-flags-24x24.6bd080ea.png";